import { AfterViewInit, Component, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { TickerInfo } from 'src/app/models/ticker';
import { Currency } from 'src/app/models/currency';
import { AuthService } from 'src/app/api/auth.service';
import { environment } from 'src/environments/environment';
import { PromotionsService } from 'src/app/api/promotions.service';
import { VerifyAndEarnPromotion } from 'src/app/models/promotions';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('heroVideo') heroVideo: ElementRef;

  readonly MOBILE_BREAK_POINT = 768;

  currencies: Currency[];
  tickers: {currency: Currency, ticker: TickerInfo}[];

  loading = false;
  error: string = null;
  lastUpdate: Date = null;

  promotion: VerifyAndEarnPromotion;
  isMobile = false;
  links = environment.links;
  currentLanguage: string;

  constructor(
    private localeService: LocaleService,
    private auth: AuthService,
    private promotionsService: PromotionsService
  ) {
    this.currentLanguage = this.localeService.currentLocale;
  }

  ngAfterViewInit() {
    this.onResize();
    this.getPromotions();
  }

  getPromotions() {
    this.loading = true;
    this.promotionsService.verifyAndEarn().subscribe(response => {
      this.loading = false;
      this.promotion = response;
    }, err => {
      this.loading = false;
      this.promotion = null;
    });
  }

  isLoggedIn() {
    return this.auth.getToken();
  }

  onPricesUpdate(date) {
    this.lastUpdate = date;
  }

  playVideo() {
    const video = this.heroVideo ? this.heroVideo.nativeElement : null;
    if (video) {
      video.muted = true;
      video.play();
      video.oncanplaythrough = function() {
        video.muted = true;
        video.play();
      }
    }
  }

  @HostListener('window:resize')
  onResize() {
    const width = window.screen.width;

    if (width <= this.MOBILE_BREAK_POINT) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
      this.playVideo();
    }
  }
}
